import React from 'react';
import { Switch, Route } from 'react-router-dom';

import MainPage from '../pages/MainPage';
import FirstBountyPage from '../pages/FirstBounty';
import SecondBountyPage from '../pages/SecondBounty';
import MegaBounty from '../pages/MegaBounty';
import NewBounty from '../pages/NewBounty';
import AdminOfBounty from '../pages/AdminOfPage';
import AdminOfBountyNew from '../pages/AdminOfBountyNew';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={MainPage} />
    <Route path="/firstbounty/:bountyId+" component={FirstBountyPage} />
    <Route path="/secondbounty/:bountyId+" component={SecondBountyPage} />
    <Route path="/megabounty/:bountyId+" component={MegaBounty} />
    <Route path="/newBounty/:bountyId+" component={NewBounty} />
    <Route
      path="/JohnAdminOfWorkInBounty/:bountyId+"
      component={AdminOfBounty}
    />
    <Route
      path="/JohnAdminOfWorkNewBounty/:bountyId+"
      component={AdminOfBountyNew}
    />
  </Switch>
);

export default Routes;
